module.exports = __webpack_public_path__ + "img/footer-link-22.3ef3eda4.png";